import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeReportAdmin, getListReports } from '../../actions/reportActions'
import ReportedUserList from '../../containers/ReportedUser/ReportedUserList'

const ReportedUsers = () => {
const dispatch = useDispatch()
const {listOfReports} = useSelector(state=>state.postAdmin)
  useEffect(() => {
    dispatch(getListReports(1))
  
    return () => {
      
    }
  }, [])
  const changeReport = (status,id)=>{
    dispatch(changeReportAdmin(status,id))
  }
  return (
    <ReportedUserList listOfReports={listOfReports} changeReport={changeReport}/>
  )
}

export default ReportedUsers